import React from 'react';
import { StyledVerticalContainer } from '../Container';
import { StyledButton, StyledText } from './ButtonActions.styled';

export interface IButtonProps {
	title: string;
	onExit?: () => void;
}

const ButtonActions: React.FC<IButtonProps> = ({ title, onExit }) => {
	return (
		<StyledVerticalContainer>
			<StyledText>{title}</StyledText>
			<StyledButton onClick={onExit}>Выйти</StyledButton>
		</StyledVerticalContainer>
	);
};

export { ButtonActions };
